import { Button, Modal, Radio, Typography, message } from "antd";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../core/index-core";

const { Title } = Typography;

const psOptions = [
  { label: "Sentences", value: "sentences" },
  { label: "Bullet Points", value: "bullet_points" },
];

const writingOptions = [
  { label: "Verbose", value: "verbose" },
  { label: "Concise", value: "concise" },
]


const SettingsModal = ({ visible, onClose, selectedDoctorId }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchSettings = async () => {
    if (!selectedDoctorId) return;
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(
        `clinician/${selectedDoctorId}/settings`
      );
      setSettings({
        pastSummary: {
          paragraphStyle: data.past_summary.paragraph_style,
          writingStyle: data.past_summary.writing_style,
          // Preserve fields that have no UI controls to avoid resetting on save
          previousSessionsForSummary: data.past_summary.previous_sessions_for_summary,
          includeAllPhysicians: data.past_summary.include_all_physicians,
          focusArea: data.past_summary.focus_area,
        },
        aiNotes: {
          paragraphStyle: data.ai_notes.paragraph_style,
        },
      });
    } catch (e) {
      console.error(e);
      message.error("Failed to load settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(visible) {
      fetchSettings();
    }
  }, [selectedDoctorId, visible]);

  const handleSave = async () => {
    if (!settings) return;
    setSaving(true);
    try {
      const payload = {
        past_summary: {
          paragraph_style: settings.pastSummary.paragraphStyle,
          writing_style: settings.pastSummary.writingStyle,
          previous_sessions_for_summary: settings.pastSummary.previousSessionsForSummary,
          include_all_physicians: settings.pastSummary.includeAllPhysicians,
          focus_area: settings.pastSummary.focusArea,
        },
        ai_notes: {
          paragraph_style: settings.aiNotes.paragraphStyle,
        },
      };

      await axiosInstance.patch(
        `clinician/${selectedDoctorId}/settings`,
        payload
      );
      message.success("Settings saved");
      onClose?.();
    } catch (e) {
      console.error(e);
      message.error("Failed to save settings");
    } finally {
      setSaving(false);
    }
  };
  return (
    <Modal
      title="Settings"
      width={610}
      open={visible}
      onCancel={onClose}
      confirmLoading={saving}
      footer={[
        <Button
          metrics-label="Save Settings"
          key="save"
          type="primary"
          onClick={handleSave}
          loading={saving}
          disabled={!settings || loading}
        >
          Save
        </Button>,
      ]}
    >
      <div className="flex flex-col gap-y-6 pb-4">
        <Title level={5} className="font-medium !text-text !text-sm">
          Past-Summary
        </Title>
        <div className="text-lightText flex justify-between items-center">
          <div>Paragraph Style</div>
          <Radio.Group
            options={psOptions}
            value={settings?.pastSummary?.paragraphStyle}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                pastSummary: {
                  ...prev.pastSummary,
                  paragraphStyle: e.target.value,
                },
              }))
            }
            className="text-sm text-lightText font-medium"
          />
        </div>

        <div className="text-lightText flex justify-between items-center">
          <div>Writing Style</div>
          <Radio.Group
            options={writingOptions}
            value={settings?.pastSummary?.writingStyle}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                pastSummary: {
                  ...prev.pastSummary,
                  writingStyle: e.target.value,
                },
              }))
            }
            className="text-sm text-lightText font-medium"
          />
        </div>
      </div>

      <div className="border-t border-b border-[#f0f0f0] py-4 gap-y-6 flex flex-col">
        <Title level={5} className="font-medium !text-text !text-sm">
          AI Notes
        </Title>
        <div className="flex justify-between text-lightText text-sm font-medium">
          <div>Paragraph Style</div>
          <Radio.Group
            options={psOptions}
            value={settings?.aiNotes?.paragraphStyle}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                aiNotes: {
                  ...prev.aiNotes,
                  paragraphStyle: e.target.value,
                },
              }))
            }
            className="text-sm text-lightText font-medium"
          />
        </div>
      </div>
    </Modal>
  );
};

export default SettingsModal;
